export interface ShippingQuote {
    msg:    string;
    status: boolean;
    result: Result[];
}

export interface Result {
    service:      Service;
    price:        number;
    price_iva:    number;
    min_delivery: Date;
    max_delivery: Date;
    description:  string;
    pickup?:      Pickup;
    address?:     Address;
    hours?:       Hour[];
}

export interface Address {
    address:   string;
    number:    string;
    floor:     string;
    locality:  string;
    city:      string;
    province:  string;
    country:   string;
    phone:     string;
    zipcode:   string;
    latitude:  string;
    longitude: string;
}

export interface Hour {
    day:   number;
    start: string;
    end:   string;
}

export interface Pickup {
    id:   string;
    name: string;
}

export interface Service {
    id:          number;
    name:        string;
    type:        Type;
    description: string;
}

export enum Type {
    Pickup = "pickup",
    Ship = "ship",
}